var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-content',[_c('v-container',{attrs:{"fill-height":"","align-center":"","justify-center":""}},[_c('img',{attrs:{"src":require("../../assets/images/logo.svg")}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }